import React from 'react';
import { useSelector } from 'react-redux';
import { Info } from 'luxon';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import { MARKET_START_DAYS } from '../../constants/marketConstants';

const getWeekdaysInMarketOrder = (startDay) => {
  const weekdays = Info.weekdays('short');
  return [...weekdays
    .splice(-1 + startDay), ...weekdays.slice(0, 6 + startDay)];
};

const DaysOfTheWeek = ({
  className,
}) => {
  const locale = useSelector(getActiveLocaleSelector);

  return (
    <div className={clsx('flex', className)}>
      {
        getWeekdaysInMarketOrder(MARKET_START_DAYS[locale]).map((weekday) => (
          <div key={weekday} className="flex-item-grow text-align-center">
            {weekday}
          </div>
        ))
      }
    </div>
  );
};

DaysOfTheWeek.propTypes = {
  className: PropTypes.string,
};

DaysOfTheWeek.defaultProps = {
  className: null,
};

export default React.memo(DaysOfTheWeek);
